import React from 'react';
import {Platform, useWindowDimensions, View} from 'react-native';

import Carousel from '/component/base/Carousel';
import Gutter from '/component/layout/Gutter';
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {withTranslation} from '/provider/TranslationProvider';

import DashboardMetricCard from '../DashboardMetricCard/DashboardMetricCard';

import {styles} from './DashboardMetricCards.style';
import {DashboardMetricCardsProps} from './DashboardMetricCards.types';
import {generateCards} from './DashboardMetricCards.util';

export const DashboardMetricCards = ({
  tt = (key: string, defaultValue: string = '') => defaultValue,
  ts = (key: string, defaultValue: string = '') => defaultValue,
  onShowInfoPopover = () => {},
  totalGenerationVolumeMetrics = {},
  frontLineCoachMetrics = {},
  gen0CoachMetrics = {},
  isBusinessLeaderOrBusinessCoach = false,
  isBusinessLeader = false,
  onShowReport = () => {},
  lastPaidRank = '',
}: DashboardMetricCardsProps) => {
  const cards = generateCards({
    frontLineCoachMetrics,
    gen0CoachMetrics,
    isBusinessLeader,
    isBusinessLeaderOrBusinessCoach,
    totalGenerationVolumeMetrics,
    tt,
    ts,
  });

  const IsWeb = Platform.OS === 'web';
  const {width} = useWindowDimensions();
  const isSmallScreen = width < 750;
  const availableWidth =
    IsWeb && !isSmallScreen ? Math.min(width, MAX_CONTENT_WIDTH) : width - 80;
  const cardGap = 5;
  const carouselHorizontalPadding =
    IsWeb && !isSmallScreen ? indent + indent * 0.75 : 0;
  const multiCardAvailableWidth = Math.max(
    0,
    availableWidth - carouselHorizontalPadding,
  );
  const ScreenOSBasedWidth =
    IsWeb && !isSmallScreen
      ? cards.length === 1
        ? availableWidth
        : (multiCardAvailableWidth - cardGap * (cards.length - 1)) /
          cards.length
      : availableWidth;

  return cards.length === 1 ? (
    <Gutter style={styles.singleCard}>
      <DashboardMetricCard
        {...cards[0]}
        onShowInfoPopover={onShowInfoPopover}
        onShowReport={onShowReport}
        lastPaidRank={lastPaidRank}
        style={{width: ScreenOSBasedWidth}}
      />
    </Gutter>
  ) : IsWeb && !isSmallScreen ? (
    <Gutter style={styles.singleCard}>
      <View style={styles.webMultiCardContainer}>
        {cards.map((card, index) => (
          <DashboardMetricCard
            key={card.heading}
            {...card}
            onShowInfoPopover={onShowInfoPopover}
            onShowReport={onShowReport}
            lastPaidRank={lastPaidRank}
            style={{
              width: ScreenOSBasedWidth,
              marginRight: index === cards.length - 1 ? 0 : cardGap,
            }}
          />
        ))}
      </View>
    </Gutter>
  ) : (
    <Carousel
      cardTitles={cards.map(card => card.heading)}
      snapToInterval={ScreenOSBasedWidth + cardGap}
      indicatorDots={IsWeb ? width < 800 : true}>
      {cards.map((card, index) => (
        <DashboardMetricCard
          key={card.heading}
          {...card}
          onShowInfoPopover={onShowInfoPopover}
          onShowReport={onShowReport}
          lastPaidRank={lastPaidRank}
          style={{
            width: ScreenOSBasedWidth,
            marginRight: index === cards.length - 1 ? 0 : cardGap,
          }}
        />
      ))}
    </Carousel>
  );
};
export default withTranslation('screen.dashboard.section.DashboardMetricCards')(
  DashboardMetricCards,
);
